/* SkinCeutics Theme — Global cart + UI behavior */

document.addEventListener('DOMContentLoaded', function () {
  initCartDrawer();
  initMobileNav();
  initRevealOnScroll();
  initFaqAccordions();
  initProductTabs();
  initVariantPills();
  initQtySelectors();
  initThumbGallery();
});

/* ---------- TOAST ---------- */
function showThemeToast(msg) {
  var t = document.querySelector('.theme-toast');
  if (!t) {
    t = document.createElement('div');
    t.className = 'theme-toast';
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._hideTimer);
  t._hideTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
}

/* ---------- CART DRAWER (Shopify AJAX Cart API) ---------- */
function initCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (!drawer || !overlay) return;

  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleCartDrawer();
    });
  });
  overlay.addEventListener('click', toggleCartDrawer);

  document.querySelectorAll('[data-close-cart]').forEach(function (btn) {
    btn.addEventListener('click', toggleCartDrawer);
  });

  // Add to cart forms (AJAX)
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            showThemeToast(data.description || 'Could not add to cart');
            return;
          }
          showThemeToast((data.product_title || 'Item') + ' added to cart!');
          refreshCartDrawer();
          openCartDrawer();
        })
        .catch(function () {
          showThemeToast('Something went wrong. Please try again.');
        });
    });
  });

  // Quick add-to-cart buttons (data-quick-add="variantId")
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-quick-add');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) { showThemeToast(data.description || 'Could not add to cart'); return; }
          showThemeToast('Added to cart!');
          refreshCartDrawer();
          openCartDrawer();
        });
    });
  });

  refreshCartDrawer();
}

function toggleCartDrawer() {
  document.getElementById('cart-drawer').classList.toggle('open');
  document.getElementById('cart-overlay').classList.toggle('active');
}
function openCartDrawer() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('active');
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var badge = document.getElementById('cart-count-badge');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'inline' : 'none';
      }
      var body = document.getElementById('cart-drawer-body');
      var footer = document.getElementById('cart-drawer-footer');
      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty-msg">Your cart is empty.<br>Start building your ritual ✦</div>';
        if (footer) footer.style.display = 'none';
        return;
      }
      body.innerHTML = cart.items.map(function (item) {
        return '<div class="cart-line-item">' +
          '<div class="cli-img"><img src="' + item.image + '" alt="' + item.product_title + '"></div>' +
          '<div class="cli-info" style="flex:1">' +
            '<div class="cli-name">' + item.product_title + '</div>' +
            '<div class="cli-price">' + formatMoney(item.final_line_price) + ' <span style="color:var(--color-lgray);font-size:12px">×' + item.quantity + '</span></div>' +
          '</div>' +
          '<button class="cli-remove" data-remove-key="' + item.key + '">×</button>' +
        '</div>';
      }).join('');
      if (footer) {
        footer.style.display = 'block';
        var totalEl = document.getElementById('cart-total-amount');
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      }
      body.querySelectorAll('[data-remove-key]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-remove-key');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(refreshCartDrawer);
        });
      });
    });
}

function formatMoney(cents) {
  var amount = (cents / 100).toFixed(0);
  return (window.themeMoneyFormat || 'Rs. {{amount}}').replace('{{amount}}', Number(amount).toLocaleString());
}

/* ---------- MOBILE NAV ---------- */
function initMobileNav() {
  var toggle = document.querySelector('.mobile-nav-toggle');
  var nav = document.querySelector('.nav-links');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function () {
    nav.classList.toggle('mobile-open');
  });
}

/* ---------- SCROLL REVEAL ---------- */
function initRevealOnScroll() {
  var els = document.querySelectorAll('.reveal-on-scroll');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  els.forEach(function (el) { obs.observe(el); });
}

/* ---------- FAQ ACCORDIONS ---------- */
function initFaqAccordions() {
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      q.closest('.faq-item').classList.toggle('open');
    });
  });
}

/* ---------- PRODUCT TABS ---------- */
function initProductTabs() {
  document.querySelectorAll('.product-tabs-nav').forEach(function (nav) {
    var container = nav.closest('.product-tabs');
    nav.querySelectorAll('.product-tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-target');
        nav.querySelectorAll('.product-tab-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        container.querySelectorAll('.product-tab-pane').forEach(function (p) { p.classList.remove('active'); });
        var pane = container.querySelector('[data-tab-pane="' + target + '"]');
        if (pane) pane.classList.add('active');
      });
    });
  });
}

/* ---------- VARIANT PILLS ---------- */
function initVariantPills() {
  document.querySelectorAll('.variant-options').forEach(function (group) {
    group.querySelectorAll('.variant-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        group.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('selected'); });
        pill.classList.add('selected');
        var form = group.closest('form');
        if (form) {
          var hidden = form.querySelector('input[name="id"]');
          if (hidden) hidden.value = pill.getAttribute('data-variant-id');
        }
      });
    });
  });
}

/* ---------- QTY SELECTORS ---------- */
function initQtySelectors() {
  document.querySelectorAll('.qty-selector').forEach(function (sel) {
    var valueEl = sel.querySelector('.qty-value');
    var input = sel.parentElement.querySelector('input[name="quantity"]');
    sel.querySelectorAll('.qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-qty-dir') === 'inc' ? 1 : -1;
        var val = Math.max(1, parseInt(valueEl.textContent, 10) + dir);
        valueEl.textContent = val;
        if (input) input.value = val;
      });
    });
  });
}

/* ---------- PRODUCT THUMBNAIL GALLERY ---------- */
function initThumbGallery() {
  document.querySelectorAll('.product-thumbs').forEach(function (wrap) {
    var main = wrap.parentElement.querySelector('.product-main-img img');
    wrap.querySelectorAll('.product-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        wrap.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (main) main.src = thumb.getAttribute('data-full-img');
      });
    });
  });
}

/* ---------- NEWSLETTER FORM (visual feedback) ---------- */
document.addEventListener('submit', function (e) {
  if (e.target.matches('[data-newsletter-form]')) {
    // Let Shopify's native customer form handle submission;
    // this just shows a toast on click for non-JS-blocked flows.
    showThemeToast('Subscribed! Welcome to the list ✦');
  }
});
